import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 9999,
  },
}))

export default styles
